<template>
    <div class="category">
        <div :class="activeItem.name===item.name?'item active':'item'" v-for="(item,index) in category" :key="index">
            <div class="type" @click="selected(item)">{{item.name}}</div>
            <span>{{item.rate}}%</span>
        </div>
    </div>
</template>
<script>
import {structureAnalysis} from "../../../api/bigDataContract";
export default {
    name:'industryCategory',
    data(){
        return{
            category:[],
            activeItem:{
                name:'全部',
                rate:'100',
            },
        }
    },
    methods:{
        selected(item){
           this.activeItem.name=item.name;
           this.activeItem.rate=item.rate;
           this.$emit('currentChange',item)
        },
        getList() {
            structureAnalysis({}).then(res => {
                let data = res.data
                if (data.code === '000') {
                    this.category = data.content.list
                    this.category.unshift(
                        {name:'全部',rate:'100'}
                    )
                } else {
                    
                }
            }).catch(err => {
                console.log(err);
            }).finally(() => {
            })
        },
    },
    created() {
      if(this.$route.query.name){
        this.activeItem.name = this.$route.query.name
      }
      this.getList() 
    },
}
</script>
<style lang="scss" scoped>
.category{
    color:#fff;
    display:flex;
    align-items: center;
    .item{
        text-align: center;
        .type{
            min-width: 84px;
            padding:0 15px;
            height: 38px;
            line-height: 38px;
            font-size: 14px;
            font-weight:600 ;
            text-align: center;
            border:1px solid #fff;
            border-right:none;
            margin-bottom: 4px;
            cursor: pointer;
            border-radius:0px 2px 2px 0px;
        }
        span{
            color:#F5A623;
            font-size: 22px;
            font-weight:600 ;
        }
    }
    .item:last-child .type{
        border-right:1px solid #fff;
    }
    .item.active .type{
        background-color: #0A56C5;
    }
}
</style>


